import React, { Component } from 'react';
import { Card, Row, Col, CardContent, Translate, Button, Insight, Gallery, Icon, PopoverButton } from '$common';
import { Filters, LoadingGear } from '$components/project';
import CSSModules from 'react-css-modules';
import style from './insights.scss';
import { now, groupBy, omit, cloneDeep } from 'lodash';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { InsightsLoader } from '$common/loaders';

let task_form = [];
let rules = [];

@CSSModules(style, { allowMultiple: true })
export default class Insights extends Component {
  state = {
    currentImage: 0,
    lightboxIsOpen: false,
    task_form: [],
    images: [],
    isReportGenerating: false,
    selectedFilter: null,
    queryBoxes: []
  };

  componentWillMount() {
    const { project, taskFormId } = this.props;
    if (project) {
      // window.Intercom('trackEvent', 'OPENED_INSIGHTS', { project_id: project.id, form_number: taskFormId })
    }
  }

  exportPDF() {
    this.props.showNotification(Translate.get('your_report_is_being_preparing'), 'success');
    if (!this.state.isReportGenerating) this.generatePDF();
  }

  async generatePDF() {
    this.setState({ isReportGenerating: true });
    const logo = require('$shared/images/logo-dark.png');
    const doc = new jsPDF({ orientation: 'landscape' });
    let allAnswers = document.querySelectorAll('#answers > #answer');
    let self = this;

    doc.fromHTML(`
      <div style="text-align: center; width: 100%;">
        <h3 style="font-family: Arial, sans-serif; color: #8CA2BE; font-weight: normal">
          Project ID: ${self.props.project.id}
        </h3>
        <img src="${logo}" style="width: 10px; display: inline-block; margin-top: 655px"/>
      </div>
    `);

    for (let i = 0; i < allAnswers.length; i++) {
      setTimeout(() => {
        html2canvas(allAnswers[i], {
          backgroundColor: '#fff',
          allowTaint: true,
          logging: false,
          scale: 1
        }).then(canvas => {
          let img = canvas.toDataURL('image/jpeg', 0.9);
          let canvasHeight = canvas.getAttribute('height');
          let top = Math.round((545-parseInt(canvasHeight))/2);
          doc.addImage(img, 9, top > 80 ? 80 : top);
          doc.addPage();
          if (i === allAnswers.length-1) {
            this.setState({ isReportGenerating: false });
            doc.save(`insights-project-${self.props.project.id}-${now()}.pdf`);
          }
        });
      }, i * 4000);
    }
  }

  openLightbox(index) {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true
    });
  }

  closeLightbox() {
    this.setState({
      currentImage: undefined,
      lightboxIsOpen: false
    });
  }

  type(item) {
    if (item.selections) {
      if (item.selections.length > 2 && item.question_type === 'radio') {
        return 'pie';
      } else if (item.question_type !== 'radio' && item.question_type !== "dropdown") {
        return 'bar';
      } else {
        return 'line';
      }
    }

    if (item.words) {
      return 'wordcloud'
    }
  }

  switchableType(item) {
    if (item.selections) {
      if (item.selections.length > 2 && item.question_type === 'radio') {
        return 'line';
      } else if(item.question_type !== 'radio' && item.question_type !== "dropdown") {
        return 'column';
      } else {
        return 'pie';
      }
    }

    return null;
  }

  images(taskForm) {
    let images = [];
    taskForm.images.length > 0 ? 
      taskForm.images.map( (item) => {
        images.push({
          src: item,
          thumbnail: item
        });
      })
    : '';
    return images;
  }

  makeExpressionFlat(expression) {
    if (typeof expression.left === "object") {
      this.makeExpressionFlat(expression.left);
      if (typeof expression.right === "object") {
        this.makeExpressionFlat(expression.right);
      }
      rules.push(expression.operator);
    } else {
      rules.push(expression);
    }
  }

  parseExpression(expression, showNumbers = false) {
    let query = "";
    let closeParenthesis = false;
    rules = [];
    let number = 1;

    this.makeExpressionFlat(expression);
    rules.map((item) => {
      if (typeof item === "object") {
        if (rules[rules.length - 1] === "not") {
          query += rules[rules.length - 1] + ' ';
          query += item.question_option_id && showNumbers && number++ || item.question_option_id || '';
          rules[rules.indexOf(rules[rules.length - 1])] = {
            operator: rules[rules.length - 1],
            checked: true
          }
        } else {
          query += item.question_option_id && showNumbers && number++ || item.question_option_id || '';

          if (typeof rules[rules.length - 2] === "object" && rules.length > 2) {
            if (rules[rules.length - 2].question_option_id) {
              if (query[0] !== '(') {
                query = '(' + query;
              }
              if (typeof rules[rules.length - 3] === "string") {
                query += ' ' + rules[rules.length - 3] + ' ';
                rules[rules.indexOf(rules[rules.length - 3])] = {
                  operator: rules[rules.length - 3],
                  checked: true
                }
              } else if (typeof rules[rules.length - 1] === "string") {
                query += ') ' + rules[rules.length - 1] + ' ';
                rules[rules.indexOf(rules[rules.length - 1])] = {
                  operator: rules[rules.length - 1],
                  checked: true
                }
              }
            }
          } else {
            if (typeof rules[rules.length - 1] === "string") {
              query += ' ' + rules[rules.length - 1] + ' ';
              if (rules.length > 3) {
                query += '(';
              }
              closeParenthesis = true;
              rules[rules.indexOf(rules[rules.length - 1])] = {
                operator: rules[rules.length - 1],
                checked: true
              }
            } else if (typeof rules[rules.length - 2] === "string") {
              query += ' ' + rules[rules.length - 2] + ' ';
              rules[rules.indexOf(rules[rules.length - 2])] = {
                operator: rules[rules.length - 2],
                checked: true
              }
            }
          }
        }

        item.checked = true;
      }
    });

    if (closeParenthesis && query[query.length-1] !== ')') {
      query = query + ')';
    }

    return query;
  }

  selectFilter(filter, index) {
    let clonedFilter = cloneDeep(filter);

    if (this.state.selectedFilter !== index) {
      this.setState({ selectedFilter: index, selectedFilterName: filter.name });

      this.props.sendFilters({
        age_range: clonedFilter.age_range,
        gender: clonedFilter.gender,
        expression: clonedFilter.expression,
      })
    } else {
      this.setState({ selectedFilter: null });
      this.props.sendFilters({});
    }
  }

  clearSelection() {
    this.selectFilter({}, this.state.selectedFilter);
  }

  render() {
    const { project, insight, taskFormId, sendFilters, filters, savedFilters, saveFilter, deleteFilter, taskForms, createReport, customColumns } = this.props;
    const { isReportGenerating, selectedFilter } = this.state;

    if (typeof insight.length === "undefined") {
      if (insight.task_forms.length > 0 && taskFormId) {
        task_form = groupBy(insight.task_forms, 'id')[taskFormId][0];
      } else {
        task_form = insight.task_forms && insight.task_forms[0] || {};
      }
    }

    return project ? (
      <div styleName="root">
        <Row>
          <Col md="5/7">
            {
              taskForms.length > 1 ?
                <div styleName="select-insight-report">
                  {Translate.get('select_insight_report')}: &nbsp;
                  {taskForms.map( (item, index) => (
                    <a
                      key={index}
                      href={`/project/${project.id}/insights/${item.id}`}
                      styleName={item.id === parseInt(taskFormId) ? 'active' : ''}
                    >
                      {index + 1}
                    </a>
                  ) )}
                </div>
              : null
            }
          </Col>
          <Col md="2/7">
            <PopoverButton
              type="ghost"
              label={<span>{Translate.get('export_report')}&nbsp;<Icon name="cloud-download" /></span>}
              block
            >
              <Button
                type="weak"
                onClick={() => this.exportPDF()}
                loading={isReportGenerating}
                style={{ marginRight: '10px' }}
              >
                {Translate.get('pdf')}
              </Button>
              <Button
                type="weak"
                onClick={() => createReport({ type: 'xls' })}
              >
                {Translate.get('xls')}
              </Button>
            </PopoverButton>
          </Col>
        </Row>

        <br/><br/>

        <Row>
          <Col md="7/10">
            {
            typeof insight.length === "undefined" ?
              insight.task_forms.length > 0 ?
                task_form.answer_statistics ?
                  <div>
                    <div id="answers" styleName="answers">
                      {
                        Object.keys(task_form.answer_statistics).map( key =>
                          task_form.answer_statistics[key].map((item, index) =>
                            <Insight
                              data={(key === 'raws' && item.words) || item.selections}
                              type={this.type(item)}
                              switchTo={!isReportGenerating && item.question_type !== 'ordering' ? this.switchableType(item) : null}
                              key={index}
                              questionType={item.question_type}
                            >
                              <span dangerouslySetInnerHTML={{ __html: item.question_title }} />
                            </Insight>
                          )
                        )
                      }
                    </div>
                    {
                      this.images(task_form).length > 0 ?
                        <div id="not-printable">
                          <Insight
                            data={this.images(task_form)}
                            type="gallery"
                            seeMore={Translate.get('see_more')}
                            onImageClick={::this.openLightbox}
                          >
                            {Translate.get('gallery')}
                          </Insight>

                          <Gallery
                            images={this.images(task_form)}
                            lightboxIsOpen={this.state.lightboxIsOpen}
                            currentImage={this.state.currentImage}
                            onClose={::this.closeLightbox}
                            showThumbnails={true}
                          />
                        </div>
                      : null
                    }
                  </div>
                :
                  typeof task_form.sets === 'object' ?
                    <div>
                      <Insight
                        data={task_form.sets}
                        type={"set"}
                      >
                        Sets
                      </Insight>
                      <Insight
                        data={task_form.analysis.map(i => ({ count: i.difference, label: i.name }))}
                        type={"bar"}
                        hideCount
                      >
                        Difference
                      </Insight>
                      <Insight
                        data={task_form.analysis.map(i => ({ count: i.best, label: i.name }))}
                        type={"column"}
                        hideCount
                      >
                        Best
                      </Insight>
                      <Insight
                        data={task_form.analysis.map(i => ({ count: i.worst, label: i.name }))}
                        type={"column"}
                        hideCount
                      >
                        Worst
                      </Insight>
                    </div>
                  : null
              :
                <Card>
                  <br />
                  <CardContent style={{ textAlign: 'center' }}>
                    <img src={require('$shared/images/empty_state.svg')} />
                    <div dangerouslySetInnerHTML={{ __html: Translate.get('insights_report_empty') }}></div>
                  </CardContent>
                  <br />
                </Card>
            : 
              <Card>
                <LoadingGear />
                <CardContent
                  dangerouslySetInnerHTML={{ __html: Translate.get('insights_report_queued') }}
                  style={{ textAlign: 'center', marginTop: '-100px' }}
                />
                <br />
              </Card>
            }
          </Col>
          <Col md="3/10" style={{ paddingLeft: '23px' }} id="not-printable">
            {
              task_form.variables ?
                <Card header="Variables">
                  <CardContent>
                    <ul styleName="variable-list">
                      {
                        task_form.variables.map((item, index) => <li key={index}>{item}</li>)
                      }
                    </ul>
                  </CardContent>
                </Card>
              :
                <div>
                  {
                    savedFilters.length > 0 ?
                      <div styleName="item-wrapper saved-filters">
                        {
                          savedFilters.map((item, index) => (
                            <div styleName={`item ${selectedFilter === index && 'selected' || ''}`} key={index}>
                              <span styleName="remove-button" onClick={() => deleteFilter(item.id)}><Icon name="trash" /></span>
                              <span styleName="order" onClick={() => this.selectFilter(item, index)}>{item.name}</span>
                              <div styleName="content" onClick={() => this.selectFilter(item, index)}>
                                {item.age_range && <span><b>{Translate.get('age_range')}:</b> {item.age_range}</span>}
                                {item.gender && <span><b>{Translate.get('gender')}:</b> {Translate.get(item.gender)}</span>}
                                {item.expression && <span><b>{Translate.get('query')}:</b> {this.parseExpression(item.expression, true)}</span>}
                              </div>
                            </div>
                          ))
                        }
                      </div>
                      : null
                  }
                  <Filters
                    sendFilters={(values) => sendFilters(values)}
                    questions={task_form.answer_statistics}
                    filters={filters}
                    saveFilter={saveFilter}
                    selectedFilter={selectedFilter > -1 && savedFilters[selectedFilter] && savedFilters[selectedFilter].id || null}
                    selectedFilterName={selectedFilter > -1 && savedFilters[selectedFilter] && savedFilters[selectedFilter].name || ''}
                    clearSelection={::this.clearSelection}
                    customColumns={customColumns}
                    demographics={insight.workers || {}}
                  />
                </div>
            }
          </Col>
        </Row>
      </div>
    ) : <InsightsLoader />
  }

}



// WEBPACK FOOTER //
// ./src/components/project/insights/insights.js